import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { cvlData, resetGuest, updateGuest, updateGuestType } from '../../../redux/actions/trans/authAction';
import { resetCartData } from '../../../redux/actions/trans/quickcategory';
import loginApi from '../../../services/loginApi';
import ApiTrans from "../../../services/trans/trans";
import { getDecryptedItem } from '../../../helper/methods';

let api = new loginApi();
let apiTrans = new ApiTrans();
const PreloginToPostloginConnector = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [state, setState] = useState({
        // panNo: "",
        // otp: "",
        userExist: false,
        // panName: "",
        // mobileNo: "",
        // emailId: "",
        // city: "",
        // otpcount: 0,
        isGuest: false,
        isGuestNew: true,
    });

    useEffect(() => {
        const setLocalStorageAndRedux = async () => {
            try {
                let allState = state;
                let inBrowser = typeof window !== 'undefined';

                if (inBrowser) {
                    let uniqueKey = getDecryptedItem("uniqueKey");
                    let uniqueKeyData = uniqueKey || {};

                    if (uniqueKeyData?.panNo) {
                        let panNo = uniqueKeyData.panNo;
                        let payload = {
                            apiName: "clientType",
                            body: { panNo: panNo },
                        };
                        let commonRes = await api.common(payload);
                        let clientTypeInLocalStorage = localStorage.getItem('prelogin-to-postlogin-clientType');
                        let res = clientTypeInLocalStorage ? JSON.parse(clientTypeInLocalStorage) : commonRes;

                        if (res?.data?.success == true) {
                            localStorage.setItem("ClientType", JSON.stringify(res?.data));

                            let cType = localStorage.getItem('ClientType');
                            let clientType = JSON.parse(cType);

                            if (clientType) {
                                let clientTypeData = clientType?.data || {};

                                // Analysis response here.
                                if (
                                    clientTypeData?.guestClient == "MF" ||
                                    clientTypeData?.guestClient == "BOTH"
                                ) {
                                    // guest client trigger OtpGeneratePMSGuest on button click.
                                    allState["isGuest"] = true;
                                    dispatch(updateGuest());
                                } else if (
                                    clientTypeData?.existingClient == "ZBF" ||
                                    clientTypeData?.existingClient == "REDEEMZBF"
                                ) {
                                    allState["isGuest"] = false;
                                    dispatch(updateGuest());
                                    if (clientTypeData?.existingClient == "ZBF") {
                                        allState["isGuestNew"] = true;
                                    } else {
                                        allState["isGuestNew"] = false;
                                    }
                                    dispatch(updateGuestType(allState["isGuestNew"]));
                                } else if (
                                    clientTypeData?.newClient == "BOTH" ||
                                    clientTypeData?.newClient == "MF"
                                ) {
                                    allState["isGuest"] = false;
                                    dispatch(updateGuest());
                                } else {
                                    dispatch(resetGuest());
                                }
                                dispatch(resetCartData());

                                dispatch(
                                    cvlData({
                                        pan: uniqueKeyData.panNo,
                                        nameAsOnPan: uniqueKeyData.nameAsOnPan,
                                    })
                                );


                                let redirectUrl = localStorage.getItem('prelogin-to-postlogin-redirect-url') || '/portfolio';
                                let isCalcLogin = localStorage.getItem('isCalcLogin') ? true : false;

                                localStorage.removeItem('isOtm');
                                if (isCalcLogin) {
                                    if (clientTypeData?.existingClient == "ZBF" || clientTypeData?.newClient == "MF"
                                        || clientTypeData?.guestClient == "BOTH" || clientTypeData?.existingClient == "REDEEMZBF") {
                                        localStorage.setItem("SchemeName", JSON.stringify("FM"));
                                    }
                                    history.push('/sip/select-fund');
                                } else {
                                    localStorage.removeItem('prelogin-to-postlogin-clientType');
                                    localStorage.removeItem('prelogin-to-postlogin-redirect-url');
                                    history.push(redirectUrl);
                                }


                                setState((prevState) => ({
                                    ...prevState,
                                    ...allState,
                                }));

                            } else {
                                localStorage.removeItem('prelogin-to-postlogin-clientType');
                                history.push({
                                    pathname: '/login',
                                    state: {
                                        snackBarState: { open: true, severity: "error", message: "Something went wrong. Please login again." }
                                    }
                                });
                                // return;
                            }
                        } else if (res?.code == "PARAMETERS_MISSING" && res?.status == 400) {
                            localStorage.removeItem('prelogin-to-postlogin-clientType');
                            history.push({
                                pathname: '/login',
                                state: {
                                    snackBarState: { open: true, severity: "error", message: "Something went wrong. Please login again." }
                                }
                            });
                        } else {
                            localStorage.removeItem('prelogin-to-postlogin-clientType');
                            history.push({
                                pathname: '/login',
                                state: {
                                    snackBarState: { open: true, severity: "error", message: "Something went wrong. Please login again." }
                                }
                            });
                        }
                    } else {
                        localStorage.removeItem('prelogin-to-postlogin-clientType');
                        history.push({
                            pathname: '/login',
                            state: {
                                snackBarState: { open: true, severity: "error", message: "Something went wrong. Please login again." }
                            }
                        });
                        // return;
                    }

                } else {
                    history.push({
                        pathname: '/login',
                        state: {
                            snackBarState: { open: true, severity: "error", message: "Something went wrong. Please login again." }
                        }
                    });
                }
            } catch (e) {
                history.push({
                    pathname: '/login',
                    state: {
                        snackBarState: { open: true, severity: "error", message: "Something went wrong. Please login again." }
                    }
                });
            }
        }
        setLocalStorageAndRedux();
    }, [])

    return (
        <>
            <div>Loading...</div>
        </>
    )
}

export default PreloginToPostloginConnector